import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Home.module.css';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import Pajaro from '../../assets/Pajaro.svg';
import Title from '../../assets/Title.svg';

function Home() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/contact');
  };

  return (
    <div className={styles.home}>
      <Header />
      <div className={styles.content}>
        <div className={styles.mainContainer}>
          <div className={styles.leftSection}>
            <img src={Pajaro} alt="Pájaro" className={styles.pajaro} />
          </div>
          <div className={styles.rightSection}>
            <img src={Title} alt="Calculadora Ambiental" className={styles.titleImage} />
            <p className={styles.description}>
              Calcula en tiempo real la huella de carbono que dejas usando gas natural vs otros energéticos
            </p>
            <button className={styles.button} onClick={handleClick}>Comienza aquí</button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Home;